import { useState } from "react";
import PageShell from "../components/common/PageShell";
import { useAuth } from "../context/AuthContext";
import { inr } from "../utils/format";

export default function Wallet({ type }) {
  const isDeposit = type === "deposit";
  const { wallet: w } = useAuth();
  const wallet = w || {};
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("upi");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const submit = (e) => {
    e.preventDefault();
    setMsg(""); setErr("");
    const a = Number(amount);
    if (!a || a < 100) return setErr("Minimum amount is ₹100.");
    if (!isDeposit && a > (wallet.winningBalance || 0)) return setErr("Amount is more than your winning balance.");
    setMsg(`${isDeposit ? "Deposits" : "Withdrawals"} are not open yet. Your request for ${inr(a)} was not sent.`);
    setAmount("");
  };

  return (
    <PageShell title={isDeposit ? "Deposit" : "Withdraw"}>
      <section className="pg-wallet">
        <div className="pg-card"><span className="pg-muted">Deposit balance</span><div className="pg-big">{inr(wallet.depositBalance)}</div></div>
        <div className="pg-card"><span className="pg-muted">Winning balance</span><div className="pg-big">{inr(wallet.winningBalance)}</div></div>
      </section>

      <form className="pg-card" onSubmit={submit}>
        <label className="pg-label" htmlFor="amt">Amount (₹)</label>
        <input id="amt" className="pg-input" type="number" inputMode="numeric" min="100"
          value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="0" />
        <div className="pg-chips">
          {[100, 500, 1000, 5000].map((v) => (
            <button type="button" key={v} className="pg-chip" onClick={() => setAmount(String(v))}>{v}</button>
          ))}
        </div>

        <label className="pg-label" htmlFor="m">{isDeposit ? "Pay with" : "Send to"}</label>
        <select id="m" className="pg-select" value={method} onChange={(e) => setMethod(e.target.value)}>
          <option value="upi">UPI</option>
          <option value="bank">Bank transfer</option>
        </select>

        {err && <p className="pg-lose">{err}</p>}
        {msg && <p className="pg-win">{msg}</p>}
        <button className="pg-btn">{isDeposit ? "Add chips" : "Request withdrawal"}</button>
      </form>

    </PageShell>
  );
}
